import { Controller } from 'stimulus';

export default class extends Controller {
	static targets = ['sidebar', 'article'];

	toggle() {
		this.sidebarTarget.classList.toggle('hidden')
		this.sidebarTarget.classList.toggle('absolute')
		this.articleTarget.classList.toggle('ml-64')
	}
	
}
